import React from 'react';
import { Cpu, ShieldCheck, Zap, Clock, PanelRight, BarChart3, Workflow, Mic } from 'lucide-react';
export const FeaturesSection = () => {
  const features = [{
    icon: <Cpu className="h-6 w-6 text-indigo-600" data-id="element-50" />,
    title: 'Autonomous Troubleshooting',
    description: 'Our AI agent identifies and fixes technical issues without any human intervention.'
  }, {
    icon: <ShieldCheck className="h-6 w-6 text-indigo-600" data-id="element-51" />,
    title: 'Cross-Platform Support',
    description: 'Works seamlessly on both Windows and Mac OS systems with native understanding of each.'
  }, {
    icon: <Zap className="h-6 w-6 text-indigo-600" data-id="element-52" />,
    title: 'Performance Optimization',
    description: 'Automatically tunes your system for optimal performance based on your usage patterns.'
  }, {
    icon: <Clock className="h-6 w-6 text-indigo-600" data-id="element-53" />,
    title: '24/7 Availability',
    description: 'Get technical support anytime, day or night, without waiting for human support hours.'
  }, {
    icon: <Workflow className="h-6 w-6 text-indigo-600" data-id="element-54" />,
    title: 'ITSM System Integration',
    description: 'Seamlessly connects with ServiceNow, Zendesk, Freshdesk, and other ITSM platforms via API for automated ticket logging and tracking.'
  }, {
    icon: <Mic className="h-6 w-6 text-indigo-600" data-id="element-55" />,
    title: 'Voice Accessibility',
    description: 'Use voice commands to describe issues and receive audio responses, making tech support accessible to everyone through natural conversation.'
  }, {
    icon: <PanelRight className="h-6 w-6 text-indigo-600" data-id="element-56" />,
    title: 'Preventative Maintenance',
    description: 'Identifies potential issues before they cause problems and takes proactive measures.'
  }, {
    icon: <BarChart3 className="h-6 w-6 text-indigo-600" data-id="element-57" />,
    title: 'Learning System',
    description: 'Continuously improves by learning from each interaction and solution deployment.'
  }];
  return <section id="features" className="py-20 px-4 bg-white" data-id="element-58">
      <div className="max-w-6xl mx-auto" data-id="element-59">
        <div className="text-center mb-16" data-id="element-60">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-61">
            Powerful Features for Seamless Tech Support
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-62">
            Our AI agent is designed to provide enterprise-grade technical
            support with the simplicity of a personal assistant.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-63">
          {features.map((feature, index) => <div key={index} className="bg-slate-50 p-6 rounded-xl border border-slate-100 hover:shadow-md transition" data-id="element-64">
              <div className="bg-indigo-100 p-3 rounded-lg inline-block mb-4" data-id="element-65">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold mb-2 text-gray-900" data-id="element-66">
                {feature.title}
              </h3>
              <p className="text-gray-600" data-id="element-67">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};